module.exports = __webpack_public_path__ + "static/media/p2008above.3445f5e2.jpg";